module.exports = __webpack_public_path__ + "../public/img/cores-04.073ed2f6.svg";